<template>
    <div class="user-secrets">
        <div class="title">蓝湖隐私政策
            <div class="back-icon" @click="goBack"><img src="@/assets/imgs/title_back.png" /></div>
        </div>

        <p>北京尽微至广信息技术有限公司及/或其关联方（以下简称“尽微至广”、“我们”）尊重并保护个人信息，并且将以高度勤勉和审慎的义务对待这些信息。在您访问和使用蓝湖以及尽微至广提供的其他服务时，我们将按照本隐私政策（以下简称“本政策”）收集、处理及披露您的信息。我们希望通过本政策向您清晰地介绍我们对您信息的处理方式，以帮助您了解维护自己隐私权的方式。</p>

        <p>在接受本政策之前，请您仔细阅读全部内容，如您无法准确理解或不同意本政策的任一内容，请不要访问、使用蓝湖或尽微至广提供的其他任何服务。<span class="text">您通过网络页面点击确认、实际使用蓝湖服务或尽微至广所提供的其他服务等操作均表示您已阅读并充分理解本政策之内容，受其约束。</span></p>

        <p><span class="text">本政策属于《蓝湖服务条款》不可分割的一部分。您同意《蓝湖服务条款》，即视为您已经同意本政策的全部内容。</span></p>

        <p>本政策将帮助您了解以下内容：</p>

        <ul>
            <li>本政策的适用范围</li>
            <li>我们如何收集和使用您的个人信息</li>
            <li>我们如何使用cookie和同类技术</li>
            <li>我们如何共享、转让、公开披露您的个人信息</li>
            <li>我们如何保护和保存您的个人信息</li>
            <li>您的权利</li>
            <li>我们如何处理未成年人的个人信息</li>
            <li>您的个人信息如何在全球范围转移</li>
            <li>本政策如何更新</li>
            <li>如何联系我们</li>

            <div class="title">本政策的适用范围</div>
            <div>当您使用我们的任何产品和服务时，本政策即适用，无论该产品和服务是否单独设置了隐私条款，也无论您是浏览用户（访客）还是注册登录用户。请您注意，本政策不适用于以下情况：</div>
            <li>通过我们的产品和/或服务而接入的第三方服务（包括任何第三方网站）收集的信息；</li>
            <li>通过在我们产品和/或服务中进行广告服务的其他公司或机构所收集的信息。</li>
            <div>请您知悉：如果您浏览第三方网站或使用第三方的产品和/或服务时向该第三方提供您的个人信息，您的信息应当适用该第三方的隐私声明或类似政策，我们对任何第三方不当使用或披露由您提供的信息不承担任何法律责任，无论您登录或浏览上述网站、软件，或使用其产品和/或服务是否基于尽微至广的链接或引导。强烈建议您在使用上述第三方服务前先行了解、确认服务提供方的隐私保护情况。</div>

            <div class="title">我们如何收集和使用您的个人信息</div>
            <div>(一) 我们收集您的个人信息的情形</div>
            <p>“个人信息”指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。“非个人身份信息”指任何与您有关但实际上不可直接或间接辨认您身份的信息，包括以汇集、匿名或化名方式提供的个人信息。您知悉并同意，无法识别出您的个人身份的信息不属于个人信息。</p>
            <p>我们提供产品和/或服务时，可能会收集、储存下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法使用和享受我们提供的某些产品和服务，或者无法达到相关产品和/或服务拟达到的效果。</p>
            <ul>
                <li>
                    帮助您成为我们的会员
                    <ul>
                        <li>当您在蓝湖网站创建账户时，您须向我们提供会员名，设置、确认您的登录密码，提供您在中华人民共和国境内手机号码或电子邮箱账户。您提交的手机号码或邮箱账户用于您注册、登录、绑定账户、密码找回时接受验证码，并且作为您与尽微至广指定的联系方式之一，用来接受相关业务通知（如新品上线、服务变更等）。</li>
                        <li>在您注册完成蓝湖账户后，您自主可以在账户中继续填写您的信息，包括（1）您的其他个人信息，如性别、工作单位等;（2）联系信息，如地址、联系电话;（3）绑定您的微信。您若不提供这些信息，将不会影响您对蓝湖一般服务的使用。您提供的本条第（1）类信息，会帮助我们更了解您对于尽微至广服务需求，以便尽微至广有针对性地向您推广、介绍产品；您提供的本条第（2）类信息，尽微至广可能会利用如上方式向您推广、宣传产品、邮寄业务通知（含账单）或与您进行业务沟通；您提供的本条第（3）类信息，尽微至广可能会利用其帮助您实现微信消息提醒功能。</li>
                        <li>如果您仅需使用蓝湖网站的浏览、搜索等基本服务，您不需要注册成为我们的会员及提供上述信息。</li>
                    </ul>
                </li>  
                <li>
                    向您提供服务
                    <ul>
                        <li>尽微至广可能会根据相关法律规定要求您提供真实身份信息以进行实名认证，您应通过您的账号提供您的真实身份信息。您通过尽微至广账号提供真实身份信息的，尽微至广为您提供了多种方式以协助您提供信息，您应根据您的身份属性选择适合的方式。您理解并同意尽微至广有权自行或委托第三方，审查您在实名认证时提供的信息是否真实、准确及有效。</li>
                        <li>在您使用服务过程中我们会收集以下的信息：
                            <ul>
                                <li>设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备所在位置相关信息（例如IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）。我们可能会将前面两类信息进行关联，以便我们能在不同设备上为您提供一致的服务。</li>
                                <li>日志信息：当您使用我们的网站或客户端提供的服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。</li>
                                <li>用户账户的支持信息：基于您使用蓝湖服务而产生的用户的咨询记录、报障记录和针对用户故障的排障过程（如通信或通话记录），尽微至广将通过记录、分析这些信息以便更及时响应您的帮助请求，以及用于改进服务。</li>
                                <li>录音、录像、照片信息：指您使用我们的特定功能（例如语音搜索、扫码、拍照等）时，在获得您的授权后，我们收集的信息。拒绝提供该信息仅会使您无法使用上述功能，但不影响您正常使用我们的产品和/或服务的其他功能。此外，您可随时关闭相关功能。</li>
                                <li>位置信息：指您开启设备定位功能并使用我们基于位置提供的相关产品和/或服务时，我们收集的有关您位置的信息，包括：您通过具有定位功能的移动设备使用我们的产品和/或服务时，我们通过GPS或WiFi等方式收集的您的地理位置信息。您可以通过关闭定位功能随时停止我们对您的地理位置信息的收集，但之后您可能将无法使用相关服务或功能，或者无法达到相关服务拟达到的效果。</li>
                                <li>付费相关信息：为帮助您顺利完成蓝湖付费服务的订阅、退订及支付、退款，并在订阅期间持续为您提供客服、技术支持等服务，尽微至广会要求您提供完整的联系方式及支付、退款账户等信息。</li>
                            </ul>
                        </li>
                        <li>我们在向您服务时，我们会按照本政策的约定收集、使用、存储、对外提供及保护您的个人信息；超出本政策约定收集您的个人信息的，我们会另行向您说明信息收集的范围与目的，并征得您的同意后方收集提供相应服务所必要的您的信息；如您选择不提供前述信息，将会影响到您使用相应服务。</li>
                    </ul>
                </li>  
                <li>其他方分享的您的信息
                    <ul>
                        <li>当您使用我们的关联公司、合作伙伴的服务时，他们在您的授权下可能向我们分享您的相关信息；</li>
                        <li>若您以其他方式关联登录、使用我们的服务，我们会向第三方请求您的个人信息，对于我们需要但第三方无法提供的个人信息，我们仍会要求您提供。如果您拒绝提供，将可能导致您无法正常使用我们的产品和/或服务的某些功能；如果您同意提供，此时，您将授权我们读取您在该第三方账号注册的相关信息（如昵称、头像等）；</li>
                        <li>我们将会依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律法规规定的前提下，使用从第三方获得的您的个人信息。</li>
                    </ul>    
                </li>  
                <li>事先征得授权同意的例外
                    <p>请注意：在以下情形中，收集、使用个人信息无需事先征得您的授权同意：</p>
                    <ul>
                        <li>与国家安全、国防安全直接相关的；</li>
                        <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
                        <li>与犯罪侦查、起诉、审判和判决执行等直接有关的；</li>
                        <li>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
                        <li>所收集的个人信息是您自行向社会公众公开的；</li>
                        <li>从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
                        <li>根据您的要求向您提供产品或服务所必需的；</li>
                        <li>用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</li>
                        <li>法律法规规定的其他情形。</li>
                    </ul>
                </li>  
                <li>我们希望提供给您的产品和/或服务是完善的，所以我们会不断改进我们的产品和/或服务，包括技术。这意味着我们的产品和/或服务可能会经常推出新功能，可能需要收集新的信息。如果我们收集的个人信息或使用方式出现重大变化或调整，我们会通过适当的方式通知您并且可能会修订本政策。</li>
                <li>我们依照法律法规的规定，将您的个人信息存储于中华人民共和国境内。如需跨境存储，我们会单独再征得您的授权同意。</li>
                <li>您授权我们在您使用我们的产品及服务的期间使用您的个人信息，若您注销账号，我们将停止使用并删除您的个人信息。对于已匿名化的信息的存储期限和处理，我们无需取得您的授权同意，也无需作出通知。</li>
            </ul>

            <div>(二) 我们使用您的个人信息的情形</div>
            <ul>
                <li>我们出于如下目的，使用您提交以及我们收集的个人信息：
                    <ul>
                        <li>为了向您提供服务，我们会向您发送信息、通知或与您进行业务沟通，包括但不限于为保证服务完成所必须的验证码、使用服务时所必要的推送通知；</li>
                        <li>用于数据分析，以便向您提供更加优质的产品和/或服务；我们更加了解您如何接入和使用我们的产品和/或服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；</li>
                        <li>为了维护、改进服务，向您提供更符合您个性化需求的信息展示，我们利用您的服务使用信息做出特征模型并进行用户画像，向您展示、推送信息和可能的商业广告，包括但不限于关于尽微至广产品的新闻以及市场活动及优惠促销信息、尽微至广合作第三方的推广信息，或其他您可能感兴趣的内容。以上信息会明确标注“定制”字样，如果您不想接收我们给您发送的商业性电子信息，您可通过短信提示回复退订或根据信息中提供的退订方式予以退订；</li>
                        <li>我们可能以个人信息统计数据为基础，设计、开发、推广全新的产品及服务；我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息不包含您的任何身份识别信息；</li>
                        <li>为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或尽微至广相关协议、规则的情况，我们可能使用您的会员信息、并整合设备信息、有关网络日志以及我们关联公司、合作伙伴合法分享的信息，来判断您账户及交易风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施；</li>
                        <li>软件认证或管理软件升级；</li>
                        <li>让您参与有关我们产品和服务或通过我们的产品和服务发起的调查，是否参与调查将由您全权决定，并且由您自行选择提供哪些信息；</li>
                        <li>出于安全、合法调查等目的，我们可能使用您的数据做数据汇总、分析、挖掘（包括商业化利用），但这些信息都采用匿名的方式，不能识别您的身份。</li>
                    </ul>
                </li>
                <li>如超出收集个人信息时所声称的目的，或者在超出具有直接或合理关联的范围使用个人信息前，我们会再次向您告知并征得您的明示同意。</li>
                <li>为了让您有更好的体验、改善我们的产品和/或服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过我们的某一项产品和/或服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他产品和/或服务。例如，在您使用我们的一项产品或服务时所收集的信息，可能在另一产品或服务中用于向您提供特定内容，或向您展示与您相关的、而非普遍推送的信息。</li>
                <li>请您注意，除非您删除或撤回同意（即通过系统设置拒绝我们的收集和使用），您在使用我们的产品和/或服务时所提供的所有个人信息，将在您使用我们的产品和/或服务期间持续授权我们在符合本政策的范围内使用。在您注销账号后，我们将根据您的要求删除您的个人信息，或做匿名化处理，但法律法规另有规定的除外。</li>
            </ul>

            <div class="title">我们如何使用cookie和同类技术</div> 
            <li>为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。尽微至广只能读取尽微至广提供的Cookies。</li> 
            <li>借助于Cookie，能够存储您的偏好或购买清单中的付费服务等数据。当下一次您再次访问的时候，我们将显示您需要的信息；或由尽微至广通过cookies文件来辨识您的来源网站，以便尽微至广能追踪尽微至广的广告效果。</li>
            <li>我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理Cookie，您也可以清除计算机上保存的所有Cookie。大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。</li>
            <li>除Cookie外，我们有可能还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。</li>

            <div class="title">我们如何共享、转让、公开披露您的个人信息</div>
            <li>共享
                <p>我们不会与其他组织和个人共享您的个人信息，但以下情况除外：</p>
                <ul>
                    <li>在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息；</li>
                    <li>与关联方及授权合作伙伴共享：我们可能委托受信赖的关联方或合作伙伴来提供服务，因此我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和优化用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的关联方及合作伙伴无权将共享的个人信息用于任何其他用途；</li>
                    <li>在法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息；</li>
                    <li>法律法规规定的其他情形。</li>
                </ul>
                <p>目前，我们的授权合作伙伴包括如下类型：供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供基础技术服务、提供咨询、分析等专业服务。</p>
                <p>如我们与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本政策及我们要求其遵守的其他适当的保密和安全措施，我们会对其数据安全能力与环境进行调查，与其签署严格的保密协定，并只会分享特定用途所必要的个人信息。</p>
            </li>
            <li>转让
                <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
                <ul>
                    <li>在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</li>
                    <li>在尽微至广与其他法律主体者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</li>
                </ul>
            </li>
            <li>公开披露
                <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
                <ul>
                    <li>获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</li>
                    <li>或为保护蓝湖平台及其关联方用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或尽微至广平台相关协议、规则披露关于您的个人信息；</li>
                    <li>基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</li>
                </ul>
            </li>
            <li>您主动与他人共享的信息
                <ul>
                    <li>您可以通过我们的网站进行搜索问题上报、评价等，以帮助更多的用户享受到更精准的信息。</li>
                    <li>您可以利用我们的分享功能与您手机通讯录中的联系人、您的特定或不特定社交好友（如微信、微博）共享您的个人信息。请您在分享前充分考虑信息接收人的信誉情况，并建议您查看您利用的社交网络或第三方服务提供商的隐私声明，以了解他们如何处理您的信息，以便审慎决策。</li>
                </ul>
            </li>
            <li>共享、转让、公开披露个人信息时事先征得授权同意的例外
                <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
                <ul>
                    <li>与国家安全、国防安全有关的；</li>
                    <li>与公共安全、公共卫生、重大公共利益有关的；</li>
                    <li>与犯罪侦查、起诉、审判和判决执行等有关的；</li>
                    <li>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
                    <li>您自行向社会公众公开的个人信息；</li>
                    <li>从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</li>
                </ul>
            </li>


            <div class="title">我们如何保护和保存您的个人信息</div>
            <li>尽微至广非常重视您的信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息。防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</li>
            <li>我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非受到法律的允许。超出上述个人信息保存期限后，我们会对您的个人信息进行删除或匿名化处理。</li>
            <li>请您理解，在互联网行业由于技术的限制和飞速发展以及可能存在的各种恶意攻击手段，即便我们竭尽所能加强安全措施，也不可能始终保证信息的百分之百安全。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。</li>
            <li>在不幸发生个人信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</li>
            <li>我们提醒您注意，互联网并非绝对安全的环境，当您通过我们的网站中嵌入的第三方社交软件、电子邮件、短信等与其他用户交互您的地理位置或行踪轨迹信息时，不确定第三方软件对信息的传递是否完全加密，注意确保您个人信息的安全。</li>
            <li>如出现蓝湖产品和服务停止运营的情形，我们会采取合理措施保护您个人信息安全，包括及时停止继续收集个人信息的活动；停止运营的通知将以逐一送达或公告的形式通知用户；并对所持有的个人信息进行删除或匿名化处理等。</li>
            <li>我们将收集到的您的个人信息存放在中华人民共和国境内，如在符合适用法律规定的情形下因业务需要向境外传输个人信息的，我们会事先征得您的同意，并向您告知个人信息出境的目的、接收方、安全保障措施、安全风险等情况。</li>

            <div class="title">您的权利</div>
            <li>访问权
                <p>原则上您可以通过如下方式访问您的个人信息：</p>
                <ul>
                    <li>账号信息：您可以登录尽微至广网站或客户端查询、管理（变更、删除）使用尽微至广服务时而提交的基本信息（基本资料）和联系方式等信息，进行账号关联或身份认证等。</li>
                    <li>使用信息：您可以在我们的网站、客户端等服务中查阅使用记录信息等，您也可通过本政策文末提供的方式联系我们删除这些信息，我们将在核实您的身份后提供，但法律法规另有约定的除外；</li>
                    <li>其他信息：如您在此访问过程中遇到操作问题或如需获取其他前述无法获知的个人信息内容，您可通过本政策文末提供的方式联系我们，我们将在核实您的身份后提供，但法律法规另有约定的除外。</li>
                </ul>
            </li>
            <li>更正权
                <ul>
                    <li>如果您需要变更您蓝湖账户的实名认证信息，您需通过客服、电话、邮件等方式联系尽微至广，我们会协助您进行相应操作。</li>
                    <li>经对您的身份进行验证，且更正不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或更新，您可以自行在我们的网站或客户端中进行更正，或在特定情况下，尤其是数据错误时，通过本政策文末提供的联系方式将您的更正申请提交给我们，要求我们更正或更新您的数据，但法律法规另有规定的除外。但出于安全性和身份识别的考虑，您可能无法修改注册时提交的某些初始注册信息。</li>
                </ul>
            </li>
            <li>删除权
                <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
                <ul>
                    <li>如果我们处理个人信息的行为违反法律法规；</li>
                    <li>如果我们收集、使用您的个人信息，却未征得您的明确同意；</li>
                    <li>如果我们处理个人信息的行为严重违反了与您的约定；</li>
                    <li>如果我们不再为您提供产品或服务。</li>
                </ul>
                <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求</p>
                <p>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</p>
                <p>当您从我们的服务中删除信息后，我们可能不会立即备案系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
            </li>
            <li>个人信息副本索取权
                <p>如您需要您的个人信息的副本，您可以通过本政策文末提供的方式联系我们，在核实您的身份后，我们将向您提供您在我们的服务中的个人信息副本（例如基本资料、身份信息），但法律法规另有规定的除外。</p>
            </li>
            <li>撤回同意权
                <ul>
                    <li>如您想更改相关功能的授权范围（例如位置、通讯录、相机），您可以通过您的硬件设备修改个人设置、或在我们的产品或服务中的相关功能设置界面进行操作处理。如您在此过程中遇到操作问题，可以通过本政策文末提供的方式联系我们。</li>
                    <li>当您取消相关个人信息收集的授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但您知悉并同意，除非您行使前述“删除权”，否则您的该行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。</li>
                </ul>
            </li>
            <li>注销权
                <ul>
                    <li>您可以通过联系我们的客服或通过其他我们公示的方式注销您的账号（但法律法规另有规定的除外），一旦您注销账号，将无法使用我们提供的服务，因此请您谨慎操作。</li>
                    <li>我们为了保护您或他人的合法权益会结合您对我们提供的各产品的使用情况判断是否支持您的注销请求，比如若您的付费服务期限未满，则我们不会立即支持您的请求，而会提示您先进行相应处理。</li>
                    <li>除法律法规另有规定外，注销账号之后，您该账号内的所有信息将被清空，我们将并根据您的要求删除您的个人信息。您通过第三方账号（如微信、微博、QQ等）授权登录我们的服务时，需要向第三方申请注销账号。</li>
                </ul>
            </li>
            <li>提前获知产品和服务停止运营权
                <p>我们愿一直陪伴您，若因特殊原因导致我们部分或全部产品和服务被迫停止运营，我们将提前15日在产品或服务的主页面或站内信或向您发送电子邮件或其他合适的能触达您的方式通知您，并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理等，法律法规另有规定的除外。</p>
            </li>
            <li>约束信息系统自动决策
                <p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救急方式。</p>
            </li>
            <li>响应您的上述请求
                <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
                <ul>
                    <li>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</li>
                    <li>但请注意，在以下情形中，按照法律法规要求，我们将无法响应您的更正、删除、注销信息等请求：
                        <ul>
                            <li>与国家安全、国防安全直接相关的；</li>
                            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
                            <li>与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
                            <li>有充分证据表明您存在主观恶意或滥用权利的；</li>
                            <li>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</li>
                            <li>涉及商业秘密的。</li>
                        </ul>
                    </li>
                </ul>
            </li>

            <div class="title">我们如何处理未成年人的个人信息</div>
            <li>我们主要面向成人提供产品和服务。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。如您为未成年人，我们要求您请您的父母或监护人仔细阅读本政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</li>
            <li>对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</li>
            <li>尽管当地法律和习俗对未成年人的定义不同，但我们将不满14周岁的任何人均视为未成年人。</li>
            <li>如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</li>

            <div class="title">您的个人信息如何在全球范围转移</div>
            <li>我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：
                    <ul>
                        <li>法律法规有明确规定；</li>
                        <li>获得您的明确授权；</li>
                        <li>您通过互联网进行跨境交易等个人主动行为。</li>
                    </ul>
                </li>
                <li>针对以上情形，我们会确保依据本政策对您的个人信息提供足够的保护。</li>
                <li>由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。</li>
                <li>此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。</li>

            <div class="title">本政策如何更新</div>
            <li>我们的隐私政策可能变更。</li>
            <li>未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在专门页面上发布对隐私政策所做的任何变更。</li>
            <li>对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过网站公示的方式进行通知甚至向您提供弹窗提示，说明隐私权政策的具体变更内容），并会在变更生效前给您预留合理的期限供您考虑是否接受变更。若您在新版本隐私政策和用户条款生效后继续使用我们的产品和服务，即表示您已充分阅读并愿意受更新后的隐私政策和用户条款约束，若您不同意该等变更可以停止使用我们的产品和服务。</li>
            <li>本政策所指的重大变更包括但不限于：
                <ul>
                    <li>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</li>
                    <li>我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</li>
                    <li>个人信息共享、转让或公开披露的主要对象发生变化；</li>
                    <li>您参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
                    <li>我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</li>
                    <li>个人信息安全影响评估报告表明存在高风险时。</li>
                </ul>
            </li>

            <div class="title">如何联系我们</div>
            <p>您对本政策内容有任何疑问和意见，或者您对尽微至广对本政策的实践以及操作上有任何疑问和意见，请通过官方QQ群：1002536314与我们联系。您也可以将您的问题发送至zhufeng@zhibenyuan.cc，或寄到如下地址：</p>
            <p>北京市朝阳区望京SOHO塔三B座3801北京尽微至广信息技术有限公司隐私保护中心（收），邮编：100123。</p>
            <p>一般情况下，我们将在15日内回复您的请求。</p>
            <p>如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向尽微至广住所地人民法院提起诉讼来寻求解决方案。</p>
        </ul>


    </div>
</template>
<style lang="scss" scoped>
.user-secrets {
    height: 100%;
    background: #fff;
    padding-top: 40px;
    padding-bottom: 20px;
    padding-left: 14px;
    padding-right: 14px;
    overflow: auto;

    .title {
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 10px;
        position: relative;
         .back-icon {
            z-index: 10;
            opacity: 0.7;
            position: absolute;
            top: -0.5rem;
            padding: 0.5rem;
            left: -0.5rem;
            border: 0.1rem solid transparent;
            box-sizing: border-box;
            background-origin: content-box;
            img {
                width: 0.9rem;
            }
        }
    }
    .update-date {
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .effective-date {
        margin-bottom: 10px;
        font-size: 14px;
    }
    p {
        font-size: 14px;
        text-align: left;
        margin-bottom: 18px;
        .text {
            font-weight: 700;
            text-decoration: underline;
        }
        .bold {
            font-weight: 700;
        }
        .underline {
            text-decoration: underline;
        }
    }
    ul {
        font-size: 14px;
        list-style-type: disc;
        list-style-position: inside;
        text-align: left;
        padding-left: 10px;
        li {
            list-style-type: disc;
            margin-bottom: 8px;
            margin-top: 4px;
        }
        .title {
            text-align: left;
            font-size: 15px;
            font-weight: 700;
            margin-bottom: 10px;
            margin-top: 6px;
        }
        .footer {
            text-align: right;
            font-weight: bold;
        }
    }
}
</style>
<script>
// import avatar from "@/components/common/Avatar"
// import lanhuDialog from "../../components/common/lanhu-dialog"
// import actionsheet from "../../components/common/Actionsheet"
// import settingsData from '../../settings.js'
// import API from "@/api/api.js"

export default {
    name: "serverAgreement",
    components: {},
    data() {
        return {}
    },
    computed: {},
    mounted() {},
    methods: {
        goBack(){
            this.$router.go(-1)
        }
    }
}
</script>
